import { getToken } from "./../helpers/firebase";
import axios from "axios";

export const INACTIVE_SUBSCRIPTION_ERROR = "INACTIVE_SUBSCRIPTION";

const apiBaseUrl =
  process.env.API_BASE_URL || "https://business-prod.neeruweb.com";

export const getMessages = async ({
  skip = 0,
  limit = 10,
  sort = { date: -1 },
  uids = [],
}) => {
  try {
    const token = await getToken();
    const options = {
      params: { skip, limit, sort, uids },
      headers: { Authorization: token },
    };
    const response = await axios.get(`${apiBaseUrl}/messages`, options);
    return response;
  } catch (e) {
    throw e;
  }
};

export const getQrCode = async () => {
  try {
    const token = await getToken();
    const options = {
      headers: { Authorization: token },
    };
    const response = await axios.get(`${apiBaseUrl}/qrCode`, options);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const postMessage = async (message, type = 0, url) => {
  try {
    const token = await getToken();
    const response = await axios.post(
      `${apiBaseUrl}/send-message`,
      { message, type, url },
      { headers: { Authorization: token } }
    );
    return response;
  } catch (e) {
    throw e;
  }
};

export const postSingleMessage = async (
  message,
  uid,
  type = 0,
  url = "",
  replyTo = "",
  timestamp,
  id
) => {
  try {
    const token = await getToken();
    const response = await axios.post(
      `${apiBaseUrl}/send-single-message`,
      { message, uid, type, url, replyTo, timestamp, id },
      { headers: { Authorization: token } }
    );
    return response;
  } catch (e) {
    throw e;
  }
};

export const postOrganizationMessage = async (
  uids = [],
  message = "",
  type = 0,
  url
) => {
  try {
    const token = await getToken();
    const response = await axios.post(
      `${apiBaseUrl}/send-organization-message`,
      { uids, message, type, url },
      { headers: { Authorization: token } }
    );
    return response;
  } catch (e) {
    throw e;
  }
};

export const checkSubscription = (profile) => {
  const { subscription } = profile || {};
  const { active } = subscription || {};

  if (active) return profile;

  throw new Error(INACTIVE_SUBSCRIPTION_ERROR);
};

export const getMe = async () => {
  try {
    const token = await getToken();
    const { data = {} } = await axios.get(`${apiBaseUrl}/me`, {
      headers: { Authorization: token },
    });
    sessionStorage.setItem("profile", JSON.stringify(data));
    return data;
  } catch (e) {
    throw e;
  }
};

export const putProfileSettings = async (uid, body) => {
  try {
    const token = await getToken();
    return await axios.put(`${apiBaseUrl}/profile/${uid}/settings`, body, {
      headers: { Authorization: token },
    });
  } catch (e) {
    throw e;
  }
};

export const removeOrganizationLink = async (uid) => {
  try {
    const token = await getToken();
    return await axios.delete(
      `${process.env.API_BASE_URL}/profiles/${uid}/organization`,
      {
        headers: { Authorization: token },
      }
    );
  } catch (e) {
    throw e;
  }
};

export const putOrganizationLink = async (uid, body) => {
  try {
    const token = await getToken();
    return await axios.put(
      `${process.env.API_BASE_URL}/profiles/${uid}/organization`,
      body,
      {
        headers: { Authorization: token },
      }
    );
  } catch (e) {
    throw e;
  }
};

export const getOrganizationLink = async (uid) => {
  try {
    const token = await getToken();
    return await axios.get(
      `${process.env.API_BASE_URL}/profiles/${uid}/organization`,
      {
        headers: { Authorization: token },
      }
    );
  } catch (e) {
    throw e;
  }
};

export const listBusinessProfiles = async () => {
  try {
    const token = await getToken();
    return await axios.get(`${process.env.API_BASE_URL}/profiles`, {
      headers: { Authorization: token },
    });
  } catch (e) {
    throw e;
  }
};

export const putProfileBilling = async (uid, body) => {
  try {
    const token = await getToken();
    return await axios.put(`${apiBaseUrl}/profile/${uid}/billing`, body, {
      headers: { Authorization: token },
    });
  } catch (e) {
    throw e;
  }
};

export const getStatistics = async (uids = []) => {
  const params = {};
  if (uids && uids.length > 0) {
    params.uids = uids;
  }
  try {
    const token = await getToken();
    const { data = {} } = await axios.get(`${apiBaseUrl}/statistics`, {
      headers: { Authorization: token },
      params,
    });
    return data;
  } catch (e) {
    throw e;
  }
};

export const createProfile = async (profile) => {
  try {
    const token = await getToken();
    const response = await axios.post(`${apiBaseUrl}/signup`, profile, {
      headers: { Authorization: token },
    });
    return response;
  } catch (e) {
    throw e;
  }
};

export const getInvoice = () => {
  const URL = `${apiBaseUrl}/invoices/last`;
  return getToken().then((token) =>
    axios.get(URL, {
      headers: { Authorization: token },
    })
  );
};

export const getBusiness = (uid) => {
  const URL = `${apiBaseUrl}/profiles/${uid}`;
  return getToken().then((token) =>
    axios.get(URL, {
      headers: { Authorization: token },
    })
  );
};



// WEBPACK FOOTER //
// src/fetcher/api.js